import { Conversation } from "@/services";

export const CHAT_TABS = [
  {
    value: "provider",
    label: "Provider",
  },
  {
    value: "patient",
    label: "Patient",
  },
];

type RawKeys = "uuid" | "name" | "email";
export type RawConvo = { [k in RawKeys]?: string };

export const mapToNameEmail = (obj: any) => ({
  uuid: obj?.uuid,
  name: obj?.name || `${obj.firstName ?? " "} ${obj.lastName ?? " "}`,
  email: obj?.email,
});

export type ConvoTab = "provider" | "patient";

/** Only enabled, non-archived providers can be picked for a new conversation. */
export const ACTIVE_PROVIDER_FILTER = {
  status: true,
  archive: false,
} as const;

export const DISABLED_RECEIVER_TOOLTIP =
  "This provider is disabled, not able to chat with him.";

/**
 * Conversation as served by `GET /api/master/conversation`; `receiverActive` is
 * not part of the generated `Conversation` model yet.
 */
export type ChatConversation = Conversation & {
  receiverActive?: boolean;
};
